import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { Subscription } from "rxjs";

import {
  ensureMockSession,
  isMockEnvironment,
} from "@serasa/shared/utils/mock-session.util";
import { AuthService } from "../../services/auth.service";

@Component({
    selector: "pl-login",
    templateUrl: "./login.component.html",
    standalone: false
})
export class LoginPageComponent implements OnInit, OnDestroy {
  private readonly _subs: Subscription[] = [];

  constructor(
    private readonly _activatedRoute: ActivatedRoute,
    private readonly _authService: AuthService,
    private readonly _router: Router,
  ) { }

  ngOnInit(): void {
    if (isMockEnvironment()) {
      ensureMockSession();
      this._authService.loggedIn$.next(true);
      this._authService.termIsAccepted = true;
      this._router.navigate(["dashboard"]);
      return;
    }

    this._subs.push(
      this._activatedRoute.queryParams.subscribe((params: Params) => {
        const minitoken = params['minitoken'];
        const deviceFingerprint = params['deviceFingerprint'];

        localStorage.setItem('deviceFingerprint', deviceFingerprint);

        if (minitoken) {
          this._authService.callRenewApp(minitoken);
          this._setOriginClientID(minitoken);
        } else {
          this._router.navigate(["forbidden"]);
        }
      }),
    );
  }

  private _setOriginClientID(minitoken: string) {
    const decodedMinitoken: { validationToken: string; originClientId: string; userId: string } = JSON.parse(atob(minitoken));
    localStorage.setItem("originClientID", decodedMinitoken.originClientId);
  }

  ngOnDestroy(): void {
    for (const sub of this._subs) {
      sub.unsubscribe();
    }
  }
}
